<template>
    <div class="team-application-page">
        <!-- 面包屑 -->
        <div class="top_change"  >
            <div class="l_where">
                系统设置<span>/</span>流量包应用
            </div>
            <div class="middle_width flex-b">
                <div>
                    <div class="nav_name" :class="pageType === '1' ? 'active' : ''" @click="changeTable('1')">套餐列表</div>
                </div>
                <div class="nav_name" :class="pageType === '2' ? 'active' : ''" @click="changeTable('2')">订单列表
                </div>
            </div>
            <div class="r_back" @click="goBack">
                <i class="iconfont icon-fanhui"></i>
            </div>
        </div>

        <!-- 主要内容区域 -->
        <div class="table-container">
            <!-- 搜索栏 - 套餐列表 -->
            <div class="top_search flex" v-if="pageType === '1'"> 
                <Button @click="handleCreate" style="margin-left:12px" type="primary">创建</Button>
            </div>

            <!-- 套餐列表表格 -->
            <Table v-if="pageType === '1'" :columns="columns" :data="applicationList" :loading="loading" stripe style="margin-top: 20px;">
                <template slot-scope="{ index }" slot="index">
                    {{ index+1}}
                </template>
                

                <template slot-scope="{ row }" slot="appName">
                    {{ row.name || '套餐名称' }}
                </template>
                <template slot-scope="{ row }" slot="price">
                    ¥ {{ row.price || 0 }}
                </template>
                <template slot-scope="{ row }" slot="originalPrice">
                    ¥ {{ row.original_price || 0 }}
                </template>
                <template slot-scope="{ row }" slot="memberCount">
                    {{ row.num || 0 }}
                </template>
                <template slot-scope="{ row }" slot="years">
                    {{ (row.years+'年') || '一年' }}
                </template>
                <template slot-scope="{ row }" slot="action">
                    <div style="display: flex;gap: 10px;">
                        <div class="table-btn blue" @click="editApplication(row)">编辑</div>
                        <div class="table-btn danger" @click="deleteApplication(row)">删除</div>
                    </div>
                </template>
            </Table>

            <!-- 订单列表表格 -->
            <Table v-if="pageType === '2'" :columns="orderColumns" :data="orderList" :loading="loading" stripe style="margin-top: 20px;">
                <template slot-scope="{ index }" slot="index"> 
                    {{ index+1 }}
                </template>
                <template slot-scope="{ row }" slot="packageName">
                    {{ row.name || '套餐名称' }}
                </template>
                <template slot-scope="{ row }" slot="payAmount">
                    ¥ {{ row.price || 0 }}
                </template>
                <template slot-scope="{ row }" slot="memberCount">
                    {{ row.num || 0 }}
                </template>
                <template slot-scope="{ row }" slot="phone">
                    {{ row.phone || '-' }}
                </template>
                <template slot-scope="{ row }" slot="order_no">
                    {{ row.order_no || '-' }}
                </template>
                
                <template slot-scope="{ row }" slot="buyTime">
                    {{ row.created_at || '-' }}
                </template>
                <template slot-scope="{ row }" slot="expireTime">
                    {{ row.start_date || '-' }} ~ {{ row.expires_date || '-' }}
                </template>
                <template slot-scope="{ row }" slot="status">
                    {{ row.status == 1 ? '支付成功' : '已退款' }}
                </template>
                <template slot-scope="{ row }" slot="action">
                    <div style="display: flex;gap: 10px;justify-content: center;align-items: center;">
                        <div class="table-btn blue" @click="applyRefund(row)" v-if="row.status == 1">申请退款</div>
                    </div>
                </template>
            </Table>

            <!-- 分页 -->
            <div class="pagination-container">
                <Page v-if="pageType === '1'" :total="searchParams.total" :current="searchParams.page" style="text-align:right" show-elevator
                    show-total @on-change="handlePageChange" :page-size="searchParams.limit" />
                <Page v-if="pageType === '2'" :total="orderSearchParams.total" :current="orderSearchParams.page" style="text-align:right" show-elevator
                    show-total @on-change="handleOrderPageChange" :page-size="orderSearchParams.limit" />
            </div>
        </div>

        <!-- 编辑套餐对话框 -->
        <Modal v-model="editModal" :title="modalTitle" @on-ok="confirmEdit" @on-cancel="cancelEdit">
            <Form ref="editFormRef" :model="editForm" :rules="editFormRules" label-position="right" :label-width="100">
                <FormItem label="套餐名称" prop="name">
                    <Input v-model="editForm.name" placeholder="请输入套餐名称" style="width: 350px;" />
                </FormItem>
                <FormItem label="套餐价格" prop="price" >
                    <Input v-model="editForm.price" type="number" placeholder="请输入套餐价格" style="width: 150px;" />
                    <span style="margin: 0 10px;">原价</span>
                    <Input v-model="editForm.original_price" type="number" placeholder="请输入原价" style="width: 150px;" />
                </FormItem>
                <FormItem label="流量份数" prop="num">
                    <Input v-model="editForm.num" type="number" placeholder="请输入流量数" style="width: 350px;" />
                </FormItem> 
            </Form>
            <div slot="footer">
                <Button @click="cancelEdit">取消</Button>
                <Button type="primary" @click="confirmEdit">确定</Button>
            </div>
        </Modal>
        <!-- 创建套餐对话框 -->
        <Modal v-model="createModal" title="创建套餐" @on-ok="confirmCreate" @on-cancel="cancelCreate">
            <Form ref="createFormRef" :model="createForm" :rules="createFormRules" label-position="right" :label-width="100">
                <FormItem label="套餐名称" prop="name">
                    <Input v-model="createForm.name" placeholder="请输入套餐名称" style="width: 350px;" />
                </FormItem>
                <FormItem label="套餐价格" prop="price">
                    <Input v-model="createForm.price" type="number" placeholder="请输入套餐价格" style="width: 150px;" />
                    <span style="margin: 0 10px;">原价</span>
                    <Input v-model="createForm.original_price" type="number" placeholder="请输入原价" style="width: 150px;" />
                </FormItem>
                <FormItem label="流量份数" prop="num">
                    <Input v-model="createForm.num" type="number" placeholder="请输入流量份数" style="width: 350px;" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelCreate">取消</Button>
                <Button type="primary" @click="confirmCreate">确定</Button>
            </div>
        </Modal>

        <!-- 详情对话框 -->
        <Modal v-model="detailModal" title="应用详情" width="600" footer-hide>
            <div class="detail-content">
                <div class="detail-item">
                    <span class="label">应用名称：</span>
                    <span class="value">{{ currentDetail.name || '-' }}</span>
                </div>
                <div class="detail-item">
                    <span class="label">套餐名称：</span>
                    <span class="value">{{ currentDetail.team_name || '-' }}</span>
                </div>
                <div class="detail-item">
                    <span class="label">成员数量：</span>
                    <span class="value">{{ currentDetail.num || 0 }}</span>
                </div>
                <div class="detail-item">
                    <span class="label">创建时间：</span>
                    <span class="value">{{ currentDetail.created_at || '-' }}</span>
                </div> 
            </div>
        </Modal>
    </div>
</template>

<script>
import { get_setmeal_list, edit_setmenu, del_setmenu, get_order_list } from '@/api/tang'
import { up_apply_refund } from '@/api/tang'
export default {
    name: 'TeamApplication',
    data() {
        return {
            pageType: '1',
            requestType:2 , //1.团队套餐 2流量包套餐
            // 搜索参数
            searchParams: {
                keyword: '',
                limit: 20,
                page: 1,
                total: 0,
            },

            // 应用列表
            applicationList: [],
            loading: false,

            // 表格列配置
            columns: [
                {
                    title: '#',
                    slot: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: '套餐名称',
                    slot: 'appName',
                    align: 'center'
                },
                {
                    title: '价格',
                    slot: 'price',
                    align: 'center'
                },
                {
                    title: '原价',
                    slot: 'originalPrice',
                    align: 'center'
                },
                {
                    title: '流量份数',
                    slot: 'memberCount',
                    align: 'center'
                },
                {
                    title: '有效期',
                    slot: 'years',
                    align: 'center'
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: 180
                }
            ],

            // 订单列表列配置
            orderColumns: [
                {
                    title: '#',
                    slot: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: '套餐名称',
                    slot: 'packageName',
                    align: 'center'
                },
                {
                    title: '支付金额',
                    slot: 'payAmount',
                    align: 'center'
                },
                {
                    title: '流量份数',
                    slot: 'memberCount',
                    align: 'center',
                    width: 100
                },
                {
                    title: '手机号',
                    slot: 'phone',
                    align: 'center'
                },
                {
                    title: '订单号',
                    slot: 'order_no',
                    align: 'center'
                },
                {
                    title: '购买时间',
                    slot: 'buyTime',
                    align: 'center'
                },
                {
                    title: '到期时间',
                    slot: 'expireTime',
                    align: 'center',
                    width: 200
                },
                {
                    title: '状态',
                    slot: 'status',
                    align: 'center',
                    width: 100
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: 180
                }
            ],

            // 编辑对话框
            editModal: false,
            modalTitle: '编辑套餐',
            editForm: {
                id: '',
                name: '',
                price: '',
                original_price: '',
                num: ''
            },

            // 创建套餐对话框
            createModal: false,
            createForm: {
                name: '',
                price: '',
                original_price: '',
                num: ''
            },

            // 详情对话框
            detailModal: false,
            currentDetail: {},

            // 订单搜索参数
            orderSearchParams: {
                keyword: '',
                limit: 20,
                page: 1,
                total: 0,
            },
            orderList: [],

            // 创建表单验证规则
            createFormRules: {
                name: [
                    { required: true, message: '请输入套餐名称', trigger: 'blur' }
                ],
                price: [
                    { required: true, message: '请输入套餐价格', trigger: 'blur' },
                    { type: 'number', message: '套餐价格必须为数字', trigger: 'blur', transform(value) {
                        return value === '' ? '' : Number(value)
                    }}
                ], 
                num: [
                    { required: true, message: '请输入流量份数', trigger: 'blur' },
                    { type: 'number', message: '流量份数必须为数字', trigger: 'blur', transform(value) {
                        return value === '' ? '' : Number(value)
                    }}
                ]
            },

            // 编辑表单验证规则
            editFormRules: {
                name: [
                    { required: true, message: '请输入套餐名称', trigger: 'blur' }
                ],
                price: [
                    { required: true, message: '请输入套餐价格', trigger: 'blur' },
                    { type: 'number', message: '套餐价格必须为数字', trigger: 'blur', transform(value) {
                        return value === '' ? '' : Number(value)
                    }}
                ], 
                num: [
                    { required: true, message: '请输入流量份数', trigger: 'blur' },
                    { type: 'number', message: '流量份数必须为数字', trigger: 'blur', transform(value) {
                        return value === '' ? '' : Number(value)
                    }}
                ]
            }
        }
    },

    mounted() {
        this.getApplicationList()
    },

    methods: {
        handleCreate() {
            this.createModal = true
            // 在下次DOM更新后重置表单
            this.$nextTick(() => {
                if (this.$refs.createFormRef) {
                    this.$refs.createFormRef.resetFields()
                }
            })
        },
        confirmCreate() {
            if(!this.createForm.original_price){
                this.$Message.error('请输入原价')
                return
            }
            // 使用表单验证
            this.$refs.createFormRef.validate((valid) => {
                if (valid) {  
                    let params = {
                        name:this.createForm.name,
                        price:this.createForm.price,
                        original_price:this.createForm.original_price,
                        num:this.createForm.num,
                        type: this.requestType,
                        id:''
                    }
                    edit_setmenu(params).then(res => {
                        if (res.code === 200) {
                            this.$Message.success(res.msg)
                            this.createModal = false
                            this.getApplicationList()
                            // 重置表单
                            this.$refs.createFormRef.resetFields()
                        } else {
                            this.$Message.error(res.msg || '创建失败')
                        }
                    }).catch(res => {
                        this.$Message.error(res.msg || '创建失败')
                    })  
                }
            })
        },
        cancelCreate() {
            this.createModal = false
            // 重置表单
            this.$refs.createFormRef.resetFields()
        },
        // 获取应用列表
        getApplicationList() {
            this.loading = true
            let params = {
                type: this.requestType,
                page: this.searchParams.page,
                limit: this.searchParams.limit
            } 
            get_setmeal_list(params).then(res => {
                this.applicationList = res.data.data || []
                this.searchParams.total = res.data.total || 0
                this.loading = false
            }).catch(res => {
                this.$Message.error(res.msg || '获取应用列表失败')
                this.loading = false
            }) 
        },

        // 搜索列表
        searchList() {
            this.searchParams.page = 1
            this.getApplicationList()
        },

        // 分页切换
        handlePageChange(page) {
            this.searchParams.page = page
            this.getApplicationList()
        },

        // 查看详情
        viewDetail(row) {
            this.currentDetail = { ...row }
            this.detailModal = true
        },
        changeTable(type) {
            this.pageType = type
            if (type === '1') {
                this.searchParams.page = 1
                this.getApplicationList()
            } else {
                this.orderSearchParams.page = 1
                this.getOrderList()
            }
        },
        getOrderList() {
            this.loading = true
            let params = {
                type: this.requestType,
                page: this.orderSearchParams.page,
                limit: this.orderSearchParams.limit
            }
            get_order_list(params).then(res => {
                this.orderList = res.data.data || []
                this.orderSearchParams.total = res.data.total || 0
                this.loading = false
            }).catch(res => {
                this.$Message.error(res.msg || '获取订单列表失败')
                this.loading = false
            })
        },  

        // 订单列表分页切换
        handleOrderPageChange(page) {
            this.orderSearchParams.page = page
            this.getOrderList()
        },

        // 编辑套餐
        editApplication(row) {
            this.editForm = {
                id: row.id,
                name: row.name || '',
                price: row.price || '',
                original_price: row.original_price || '',
                num: (row.num.toFixed(2)+'') || 0
            } 
            this.modalTitle = '编辑套餐'
            this.editModal = true 
            
        },
        applyRefund(row) {
            this.$Modal.confirm({
                title: '申请退款',
                content: '确定要申请退款吗？',
                onOk: () => {
                    up_apply_refund({ order_id: row.id }).then(res => {
                        this.$Message.success(res.msg)
                        this.getOrderList()
                    }).catch(res => {
                        this.$Message.error(res.msg || '申请退款失败')
                    })
                }
            })
        },

        // 确认编辑
        confirmEdit() {
            if(!this.editForm.original_price){
                this.$Message.error('请输入原价')
                return
            }
            // 使用表单验证
            this.$refs.editFormRef.validate((valid) => {
                if (valid) { 
                    let params = {
                        name:this.editForm.name,
                        price:this.editForm.price,
                        original_price:this.editForm.original_price,
                        num:this.editForm.num,
                        type: this.requestType,
                        id:this.editForm.id
                    }
                    edit_setmenu(params).then(res => {
                        if (res.code === 200) {
                            this.$Message.success(res.msg)
                            this.editModal = false
                            this.getApplicationList()
                        } else {
                            this.$Message.error(res.msg || '编辑失败')
                        }
                    }).catch(res => {
                        this.$Message.error(res.msg || '编辑失败')
                    })
                }
            })
        },

        // 取消编辑
        cancelEdit() {
            this.editModal = false
            // 重置表单
            this.$refs.editFormRef.resetFields()
        },

        // 删除应用
        deleteApplication(row) {
            this.$Modal.confirm({
                title: '删除提示',
                content: '确定要删除此应用吗？删除后无法恢复！',
                onOk: () => {  
                    del_setmenu({ id: row.id }).then(res => {
                        if (res.code === 200) {
                            this.$Message.success(res.msg)
                            this.getApplicationList()
                        } else {
                            this.$Message.error(res.msg || '删除失败')
                        }
                    }).catch(res => {
                        this.$Message.error(res.msg || '删除失败')
                    })  
                },
                onCancel: () => {
                    // 取消删除
                }
            })
        },

        // 返回
        goBack() {
            this.$emit('goBack')
        }
    }
}
</script>

<style scoped lang="scss">
.middle_width {
    width: 18%;
    margin: auto;
}

.nav_name {
    font-size: 20px;
    font-weight: bold; 
    color: #545F78;
    height: 66px;
    line-height: 66px;
    cursor: pointer;
    position: relative;

    &:hover {
        color: #4877E8;
    }
}

.active {
    color: #4877E8;

    &:after {
        content: '';
        display: inline-block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background: #4877E8;
        border-radius: 1px;
    }
}

.team-application-page {
    .top_change {
        width: 100%;
        cursor: pointer;
        background: #FFFFFF;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 30px;
        box-sizing: border-box; 

        .l_where {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #1B2742;

            span {
                color: #4877E8;
            }
        }

        .r_back {
            width: 200px;
            cursor: pointer;
            text-align: end;

            .iconfont {
                font-size: 26px;
                cursor: pointer;

                &:hover {
                    color: #4877E8;
                }
            }
        }
    }

    .table-container {
        background: white;
        padding: 24px;
        border-radius: 8px;
        margin-top: 20px;

        .top_search {
            display: flex;
            align-items: center;
        }
    }

    .pagination-container {
        margin-top: 20px;
        text-align: right;
    }

    .detail-content {
        padding: 20px 0;

        .detail-item {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            font-size: 14px;

            .label {
                width: 100px;
                color: #515a6e;
                font-weight: 500;
                text-align: right;
                margin-right: 20px;
            }

            .value {
                flex: 1;
                color: #1c2438;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>
